import Image from 'next/image';
import { PropsWithChildren } from 'react'
import { imageLoader } from '../../context/utils';
import { IMedia } from '../../interfaces/media'
import Logo from './logo.component'

export interface IHeaderBackgroundLayoutProps extends PropsWithChildren {
  headerImage: IMedia;
}

const HeaderBackgroundLayout: React.FC<IHeaderBackgroundLayoutProps> = ({ headerImage, children }) => {
  return (
    <div className='relative w-full h-full flex'>
      {headerImage && <Image loader={imageLoader}
        src={headerImage.fileUrl} alt={''} layout='fill'
        objectFit='cover' />}
      <div className='absolute inset-0 z-0 bg-header-gradient-overlay w-full' />
      {children}
    </div>
  )
}

export default HeaderBackgroundLayout
